/* unplugin-vue-components disabled */import { render } from "./djs_m.vue?vue&type=template&id=1fa16982"
import script from "./djs_m.vue?vue&type=script&lang=js"
export * from "./djs_m.vue?vue&type=script&lang=js"

import "./djs_m.vue?vue&type=style&index=0&id=1fa16982&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__